const userRouter = [
  {
    path: "/",
    component: () => import("@/Views/UserView/UserMain.vue"),
    children: [
      {
        path: "",
        name: "Home",
        component: () => import("@/Views/UserView/HOME/view/HomePage.vue")
      },
      {
        path: "Ask",
        name: "askPage",
        component: () => import("@/Views/UserView/ASK/view/AskPage.vue")
      },
      {
        path: "reels",
        name: "reels",
        component: () => import("@/Views/UserView/Reels/ReelsPage.vue")
      },
      {
        path: "Guidances",
        name: "guidancepage",
        component: () => import("@/Views/UserView/GuidancesPage.vue")
      },
      {
        path: "Getapp",
        name: "getapp",
        component: () => import("@/Views/UserView/GetApp.vue")
      },
      {
        path: "Contactus",
        name: "contact",
        component: () => import("@/Views/UserView/Contact/view/ContactPage.vue")
      },
      {
        path: "Aboutus",
        name: "about",
        component: () => import("@/Views/UserView/AboutPage.vue")
      },
      {
        path: "search",
        name: "search",
        component: () => import("@/Views/UserView/SEARCH/view/SearchPage.vue")
      },
      {
        path: "auth",
        redirect: { name: "login" }
      },
      {
        path: "login",
        name: "login",
        component: () => import("@/Views/UserView/Auth/View/LoginPage.vue")
      },
      {
        path: "sigin",
        name: "sigin",
        component: () => import("@/Views/UserView/Auth/View/SiginPage.vue")
      },
      {
        path: "expert/form",
        name: "expertForm",
        component: () => import("@/Views/UserView/ExpertProfile/views/ExpertForm.vue")
      },
      {
        path: "expert/Profile",
        name: "expertProfile",
        component: () => import("@/Views/UserView/ExpertProfile/views/ExpertProfile.vue")
      },
      {
        path: "expert/Dashbord",
        name: "expertDash",
        component: () => import("@/Views/UserView/ExpertProfile/views/ExpertDash.vue")
      },
      {
        path: "expert/ViewExpert/:id",
        name: "viewExpert",
        component: () => import("@/Views/UserView/ExpertProfile/views/ViewExpert.vue")
      },
      {
        path: "notification",
        name: "notification",
        component: () => import("@/Views/UserView/Notification/view/NotificationPage.vue")
      },
      {
        path: "UserProfile",
        name: "userProfile",
        component: () => import("@/Views/UserView/UserProfile/view/ProfilePage.vue")
      },
      {
        path: "challenge/:id",
        name: "sharedChallenge",
        component: () => import("@/Views/UserView/sharedChallenge.vue"),
        props: true
      }


    ]
  }
];

export default userRouter;